export type BrokerNerdsBarkerCoreEnumsPlanType = (typeof BrokerNerdsBarkerCoreEnumsPlanType)[keyof typeof BrokerNerdsBarkerCoreEnumsPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsPlanType = {
  Unknown: 'Unknown',
  PercentageOfSales: 'PercentageOfSales',
  PercentageOfAutoPricedSales: 'PercentageOfAutoPricedSales',
  FixedRate: 'FixedRate',
  SalesBrackets: 'SalesBrackets',
  ManualPricingOnly: 'ManualPricingOnly',
} as const;
